var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingSpinner2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(-832 494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_4",
    "data-name": "Sustracci\\xF3n 4",
    d: "M18,36h0A18,18,0,0,1,5.272,5.272,18,18,0,0,1,36,18H33A15,15,0,1,0,18,33v3Z",
    transform: "translate(832 -494)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_5",
    "data-name": "Sustracci\\xF3n 5",
    d: "M15,33h0V30A15.017,15.017,0,0,0,30,15h3A18,18,0,0,1,15,33Z",
    transform: "translate(835 -491)",
    fill: "#3376c9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSpinner2);
export default __webpack_public_path__ + "static/media/loading-spinner-2.d5e06b2c.svg";
export { ForwardRef as ReactComponent };